import React, { useRef, useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import {
    addStatusFilter,
    getValue,
    rerender,
    setPriceFilterValue,
    removeStatusFilter,
} from '../../store/actions'
import './index.css'
import BaseSelect from "../BaseSelect";

const FilterSection = ({getValue, statusFilterList, removeStatusFilter, addStatusFilter}) => {
    const [selectLabels, setSelectLabels] = useState({status: 'Show all'});

    let valueInput = useRef()
    const handleOnBlur = () => {
      getValue(valueInput.current.value);
    };

    const statusOptions = {
        prop: 'status',
        options: ["All parts", "Accepted only", "Active only", "DMS == Current"]
    };

    const choseFilter = useCallback((filterProp, filterValue) => {
        if (filterValue === 'All parts') {
            console.log('empty filter worked')
            return removeStatusFilter(filterProp);
        }
        addStatusFilter(filterProp, filterValue);
    }, [addStatusFilter, removeStatusFilter])


    useEffect(() => {
        const filters = statusFilterList;
        const statusSelectLabel = filters.getByProp('status');
        setSelectLabels({
            status: statusSelectLabel ? statusSelectLabel : 'All parts',
        })
    }, [statusFilterList])


  return (
      <div style={{display: 'flex', flexDirection: "row", alignItems: 'flex-end', }}>
          <div className="header__action-filter-layout">
              <span className="header__action-descriptor">Filter by</span>
              <BaseSelect
                  format="button"
                  name={selectLabels.status}
                  selectOption={choseFilter}
                  selectOptions={statusOptions}
              />
          </div>

          <div className='info-modal__container'>
              <p className='info-modal__text'>Show greater than</p>
              <div className='info-modal__wrapper'>
                  <input ref={valueInput} type='number' className='info-modal__input' placeholder='0'
                         onBlur={handleOnBlur}
                         onKeyPress={handleOnBlur}
                  />
              </div>
          </div>
      </div>

  )
}
const mapStateToProps = ({ data: { value, statusFilterList, render } }) => ({ value, statusFilterList, render })
const mapDispatchToProps = ({ setPriceFilterValue, addStatusFilter, removeStatusFilter, rerender, getValue})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterSection)




